import { mdiClipboardArrowUpOutline, mdiEye } from '@mdi/js';
import copy from 'copy-text-to-clipboard';
import React, { useContext, useState } from 'react';
import { ToastContext } from '../../services';
import { BaseDialog } from '../base/';
import * as S from './preserved-text.styles';

interface IPreservedTextProps {
    text?: string;
    rows?: number;
    customComponent?: React.ReactElement;
    actions?: React.ReactElement[];
}

export const PreservedText: React.FunctionComponent<IPreservedTextProps> = (props: IPreservedTextProps) => {
    const { text, actions, customComponent } = props;
    if (!text) {
        return <></>;
    }

    const rows = props.rows || text.split('\n').length;

    const context = useContext(ToastContext);
    const [isShowDialog, setShowDialog] = useState(false);
    const viewText = (e: React.MouseEvent) => {
        setShowDialog(true);
    };
    const unviewText = (e: React.MouseEvent) => {
        setShowDialog(false);
    };
    const copyText = (e: React.MouseEvent) => {
        copy(text);
        context.notify && context.notify('Copied to clipboard', 'left');
    };

    return (
        <>
            <S.PreservedText>
                {customComponent ? customComponent : <S.Textarea disabled={true} rows={rows} defaultValue={text} />}
                <S.TextActions>
                    {actions}
                    <S.ActionButton onClick={viewText}>
                        <S.ActionTooltip direction="top" variant="dark" title={<span>View</span>}>
                            <S.ActionIcon path={mdiEye} size={0.75} />
                        </S.ActionTooltip>
                    </S.ActionButton>
                    <S.ActionButton onClick={copyText}>
                        <S.ActionTooltip direction="top" variant="dark" title={<span>Copy to clipboard</span>}>
                            <S.ActionIcon path={mdiClipboardArrowUpOutline} size={0.75} />
                        </S.ActionTooltip>
                    </S.ActionButton>
                </S.TextActions>
            </S.PreservedText>
            <BaseDialog open={isShowDialog} onClose={unviewText}>
                <S.ViewText>{text}</S.ViewText>
            </BaseDialog>
        </>
    );
};
